import { css } from 'styled-components';
import { Heading } from '../../../../../components/Hero/HeroPlain/styles';
import mediaQuery from '../../../../../helpers/mediaQuery';

export default css`
  ${Heading} {
    font-size: 3.25rem;

    ${mediaQuery.tabletPortrait`
      font-size: 3.75rem;
    `}
  }
`;
